<template>
  <div :class="imgListType==0?'video-wrap0':'video-wrap1'" :style="videoBgImgStyle">
    <div class="video-area">
      <video controls :src="videoSource" :webkit-playsinline="imgListType==1?false:true" :playsinline="imgListType==1?false:true"
        :x5-playsinline="imgListType==1?false:true" ref="video" @play="handlePlay" @pause="handlePause"
        :poster="poster">
        <source :src="videoSource" />
      </video>
    </div>
  </div>
</template>

<script>
export default {
  name: "Video",
  data() {
    return {
      imgListType: 0,  //控制是在页面内播放还是在弹出层播放
      imgList: [],  //视频list
      videoSource: "",  //视频url
      poster: '', //视频封面
    };
  },
  props: {
    info: {
      type: Object,
      required: true
    },
    activityId: {
      type: String,
      required: true
    },
    activityType: {
      type: Number,
      required: true
    },
    activityStatus: {
      type: Number,
      required: true
    }
  },
  inject: ['getEnterSource'],
  computed: {
    enterSource() {
      return this.getEnterSource();
    },
    videoBgImgStyle() {
      return {
        background: `url(${this.info.baseConfig.imgList[this.info.baseConfig.imgListType].backgroundImg}) center center no-repeat`
      };
    }
  },
  created() { },
  mounted() {
    this.format()
  },
  methods: {
    format() {
      this.imgListType = this.info.baseConfig.imgListType || 0
      this.imgList = this.info.baseConfig.imgList || []
      this.videoSource = this.imgList[this.imgListType].videoUrl || ''
      this.poster = this.imgList[this.imgListType].coverUrl || ''
    },
    handlePlay() {
      let video = this.$refs['video']
      // try {
      //   TDAPP.onEvent(`视频${this.info.name}`, `播控按钮`)
      // } catch (e) {
      //   console.log('打点失败', e)
      // }
      video.play()
      this.$log.senLog({
        pointID: '12010004',
        eventType: 2,
        businessData: {
          activityType: this.activityType !== undefined ? this.activityType : '',
          activityId: this.activityId || '',
          url: this.videoSource || '',
          enterSource: this.enterSource,
        }
      })
    },
    handlePause() {
      let video = this.$refs['video']
      video.pause()
      this.$log.senLog({
        pointID: '12010004',
        eventType: 2,
        businessData: {
          activityType: this.activityType !== undefined ? this.activityType : '',
          activityId: this.activityId || '',
          url: this.videoSource || '',
          enterSource: this.enterSource,
        }
      })
    },
  }
};
</script>

<style scoped lang="scss">
.video-wrap0,
.video-wrap1 {
  background-size: 100% 100% !important;
  display: flex;
  background: #f5f5f5;
  justify-content: center;
  align-items: center;

  video {
    width: 100%;
    height: 100%;
  }
}

.video-wrap0 {
  height: 440px;

  .video-area {
    width: 640px;
    height: 360px;
    position: relative;
  }
}

.video-wrap1 {
  height: 422px;

  .video-area {
    width: 100%;
    height: 422px;
    position: relative;
  }

  .poster-img {
    width: 100%;
    height: 422px;
  }
}
</style>